// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Recharts = require("recharts");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var AxisData$ReactHooksTemplate = require("./axisData.res.js");
var Recharts$ReactHooksTemplate = require("../common/Recharts.res.js");
var DataWindow$ReactHooksTemplate = require("./dataWindow.res.js");
var ChartComponentColor$ReactHooksTemplate = require("./chartComponentColor.res.js");
var GenericChartAttribute$ReactHooksTemplate = require("./genericChartAttribute.res.js");

function BarChartComponent(props) {
  var __forPdf = props.forPdf;
  var enlarged = props.enlarged;
  var onClick = props.onClick;
  var drillDownKey = props.drillDownKey;
  var chartAttribute = props.chartAttribute;
  var chartId = props.chartId;
  var forPdf = __forPdf !== undefined ? __forPdf : false;
  var renderLegend = function (value, param) {
    return JsxRuntime.jsx("span", {
                children: value,
                className: "text-xs"
              });
  };
  var renderToolTip = function (data) {
    var payload = data["payload"];
    if (payload == null) {
      return JsxRuntime.jsx("div", {});
    }
    var newPayload = Js_dict.values(payload);
    var match = newPayload.length;
    if (match === 0) {
      return JsxRuntime.jsx("div", {});
    }
    console.log(Caml_array.get(newPayload, 0));
    var payloadData = Js_dict.get(Caml_array.get(newPayload, 0), "payload");
    if (payloadData !== undefined) {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("ul", {
                        children: Belt_Array.map(Js_dict.entries(payloadData), (function (param) {
                                return JsxRuntime.jsxs("li", {
                                            children: [
                                              JsxRuntime.jsx("span", {
                                                    children: String(param[0])
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: " : "
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: param[1]
                                                  })
                                            ],
                                            className: "recharts-tooltip-item py-3-px"
                                          });
                              })),
                        className: "recharts-tooltip-itemlist"
                      }),
                  className: "recharts-default-tooltip bg-white border border-solid border-1\n            border-gray-300 p-2 w-64 max-w-full text-sm"
                });
    } else {
      return JsxRuntime.jsx("div", {});
    }
  };
  var layout = GenericChartAttribute$ReactHooksTemplate.layout(chartAttribute);
  var valueSuffix = GenericChartAttribute$ReactHooksTemplate.valueSuffix(chartAttribute);
  var showLabelsOnlyWhenEnlarged = GenericChartAttribute$ReactHooksTemplate.showLabelsOnlyWhenEnlarged(chartAttribute);
  var shouldRenderValueLabels = !showLabelsOnlyWhenEnlarged || enlarged;
  var xAxisKey = AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute));
  var yAxisKeys = Belt_List.map(GenericChartAttribute$ReactHooksTemplate.yAxis(chartAttribute), AxisData$ReactHooksTemplate.key);
  var json = GenericChartAttribute$ReactHooksTemplate.data(chartAttribute);
  var tableRows = json !== undefined ? Belt_List.map(Belt_List.fromArray(Belt_Option.getWithDefault(Js_json.decodeArray(json), [])), (function (item) {
            var rowObj = Belt_Option.getWithDefault(Js_json.decodeObject(item), {});
            var value = Js_dict.get(rowObj, xAxisKey);
            var categoryValue;
            if (value !== undefined) {
              var stringValue = Js_json.decodeString(value);
              if (stringValue !== undefined) {
                categoryValue = stringValue;
              } else {
                var numberValue = Js_json.decodeNumber(value);
                categoryValue = numberValue !== undefined ? numberValue.toString() : "";
              }
            } else {
              categoryValue = "";
            }
            var dataValues = Belt_List.map(yAxisKeys, (function (key) {
                    var value = Js_dict.get(rowObj, key);
                    if (value === undefined) {
                      return "";
                    }
                    var numberValue = Js_json.decodeNumber(value);
                    if (numberValue !== undefined) {
                      return numberValue.toString();
                    }
                    var stringValue = Js_json.decodeString(value);
                    if (stringValue !== undefined) {
                      return stringValue;
                    } else {
                      return "";
                    }
                  }));
            return [
                    categoryValue,
                    dataValues
                  ];
          })) : /* [] */0;
  var isStacked = Belt_List.reduce(GenericChartAttribute$ReactHooksTemplate.yAxis(chartAttribute), false, (function (acc, xs) {
          if (Belt_Option.isSome(AxisData$ReactHooksTemplate.stackId(xs))) {
            return true;
          } else {
            return false;
          }
        }));
  var tableRowsForRender = forPdf ? Belt_Option.getWithDefault(Belt_List.take(tableRows, 200), tableRows) : tableRows;
  var isPdfTableTruncated = forPdf && Belt_List.length(tableRows) > 200;
  var formatChartValue = function (value) {
    if (valueSuffix !== undefined) {
      return value + valueSuffix;
    } else {
      return value;
    }
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Recharts.ResponsiveContainer, {
                            children: JsxRuntime.jsxs(Recharts.BarChart, {
                                  data: GenericChartAttribute$ReactHooksTemplate.data(chartAttribute),
                                  margin: Caml_option.some(Recharts$ReactHooksTemplate.Margin.make(20, 65, 0, 25)),
                                  layout: layout,
                                  children: [
                                    JsxRuntime.jsx(Recharts.CartesianGrid, {}),
                                    layout === "vertical" ? JsxRuntime.jsx(Recharts.XAxis, {
                                            minTickGap: 1,
                                            type: "number"
                                          }) : JsxRuntime.jsx(Recharts.XAxis, {
                                            minTickGap: 2,
                                            dataKey: AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute)),
                                            tick: Caml_option.some(Recharts$ReactHooksTemplate.Tick.make(12, 0, "bottom")("middle", 10, true)),
                                            interval: isStacked ? 0 : "preserveStartEnd",
                                            height: 80,
                                            tickMargin: 13,
                                            tickFormatter: (function (key) {
                                                return Js_array.joinWith(" ", Js_string.split("-", Js_array.joinWith(" ", Js_string.split("_", key))));
                                              })
                                          }),
                                    layout === "horizontal" ? JsxRuntime.jsx(Recharts.YAxis, {
                                            minTickGap: 1,
                                            tick: Caml_option.some(Recharts$ReactHooksTemplate.Tick.make(12, undefined, undefined)("end", 10, true))
                                          }) : JsxRuntime.jsx(Recharts.YAxis, {
                                            minTickGap: 1,
                                            dataKey: AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute)),
                                            width: 300,
                                            tick: Caml_option.some(Recharts$ReactHooksTemplate.Tick.make(12, undefined, "top")("end", 300, true)),
                                            interval: isStacked ? 0 : "preserveStartEnd",
                                            tickFormatter: (function (key) {
                                                return Js_array.joinWith(" ", Js_string.split("-", Js_array.joinWith(" ", Js_string.split("_", key))));
                                              }),
                                            type: "category"
                                          }),
                                    GenericChartAttribute$ReactHooksTemplate.enableDataWindow(chartAttribute) ? DataWindow$ReactHooksTemplate.show(chartAttribute, enlarged, props.containerWidth) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                    GenericChartAttribute$ReactHooksTemplate.dataLength(chartAttribute) > 0 ? JsxRuntime.jsx(Recharts.Tooltip, {
                                            content: renderToolTip
                                          }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                    JsxRuntime.jsx(Recharts.Legend, {
                                          formatter: renderLegend
                                        }),
                                    $$Array.of_list(Belt_List.mapWithIndex(GenericChartAttribute$ReactHooksTemplate.yAxis(chartAttribute), (function (i, xs) {
                                                var stackId = AxisData$ReactHooksTemplate.stackId(xs);
                                                var json = GenericChartAttribute$ReactHooksTemplate.data(chartAttribute);
                                                return JsxRuntime.jsxs(Recharts.Bar, {
                                                            dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                            barSize: 30,
                                                            fill: ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute)),
                                                            stackId: stackId,
                                                            onClick: (function (data, param) {
                                                                var key = Json_decode.field(AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute)), Json_decode.string, Belt_Option.getExn((data == null) ? undefined : Caml_option.some(data)).payload);
                                                                Curry._3(onClick, key, chartId, GenericChartAttribute$ReactHooksTemplate.onClick(chartAttribute));
                                                              }),
                                                            children: [
                                                              shouldRenderValueLabels ? JsxRuntime.jsx(Recharts.LabelList, {
                                                                      dataKey: AxisData$ReactHooksTemplate.key(xs),
                                                                      position: "top",
                                                                      fill: "#111827",
                                                                      fontSize: 10,
                                                                      formatter: formatChartValue
                                                                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                                              json !== undefined ? Belt_Array.map(Belt_Option.getWithDefault(Js_json.decodeArray(json), []), (function (xs) {
                                                                        return JsxRuntime.jsx(Recharts.Cell, {
                                                                                    fill: drillDownKey !== undefined && !(drillDownKey === "" || Caml_obj.equal(Js_json.decodeString(Belt_Option.getWithDefault(Js_dict.get(Belt_Option.getWithDefault(Js_json.decodeObject(xs), {}), AxisData$ReactHooksTemplate.key(GenericChartAttribute$ReactHooksTemplate.xAxis(chartAttribute))), null)), String(drillDownKey))) ? "#d8d8d8" : ChartComponentColor$ReactHooksTemplate.getColorById(i, GenericChartAttribute$ReactHooksTemplate.colors(chartAttribute))
                                                                                  }, String(chartId));
                                                                      })) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                            ]
                                                          }, String(i));
                                              })))
                                  ]
                                })
                          }),
                      className: "w-full " + props.chartHeight + " p-20-px"
                    }),
                isStacked || !enlarged ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("table", {
                                children: [
                                  JsxRuntime.jsx("thead", {
                                        children: JsxRuntime.jsxs("tr", {
                                              children: [
                                                JsxRuntime.jsx("th", {
                                                      children: xAxisKey,
                                                      className: "px-3 py-2 border border-gray-200 text-left font-bold " + (
                                                        forPdf ? "break-words" : ""
                                                      )
                                                    }),
                                                $$Array.of_list(Belt_List.map(yAxisKeys, (function (key) {
                                                            return JsxRuntime.jsx("th", {
                                                                        children: key,
                                                                        className: "px-3 py-2 border border-gray-200 text-left font-bold " + (
                                                                          forPdf ? "break-words" : ""
                                                                        )
                                                                      });
                                                          })))
                                              ],
                                              className: "bg-gray-50"
                                            })
                                      }),
                                  JsxRuntime.jsx("tbody", {
                                        children: $$Array.of_list(Belt_List.map(tableRowsForRender, (function (param) {
                                                    var categoryValue = param[0];
                                                    return JsxRuntime.jsxs("tr", {
                                                                children: [
                                                                  JsxRuntime.jsx("td", {
                                                                        children: categoryValue === "" ? "default" : categoryValue,
                                                                        className: "px-3 py-2 border border-gray-200 font-medium " + (
                                                                          forPdf ? "break-words" : ""
                                                                        )
                                                                      }),
                                                                  $$Array.of_list(Belt_List.map(param[1], (function (value) {
                                                                              return JsxRuntime.jsx("td", {
                                                                                          children: formatChartValue(value),
                                                                                          className: "px-3 py-2 border border-gray-200 " + (
                                                                                            forPdf ? "break-words" : ""
                                                                                          )
                                                                                        });
                                                                            })))
                                                                ]
                                                              });
                                                  })))
                                      })
                                ],
                                className: forPdf ? "w-full table-fixed border border-1 border-gray-200 text-xs" : "min-w-full border border-1 border-gray-200 text-xs"
                              }),
                          isPdfTableTruncated ? JsxRuntime.jsx("div", {
                                  children: "Showing first " + String(200) + " rows in PDF export",
                                  className: "text-xs text-gray-600 mt-2"
                                }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                        ],
                        className: forPdf ? "w-full mt-2" : "w-full overflow-x-auto mt-2"
                      })
              ],
              className: "flex flex-col items-center"
            });
}

var make = BarChartComponent;

exports.make = make;
/* recharts Not a pure module */
